import { Layout } from '@loadsmart/miranda-react'

import { Item } from 'core/ui/components/item/Item'

import { showAccessorials, type Quote } from '../domain/Quote'
import { QuoteAccessorials } from './QuoteAccessorials'

export type QuoteDetailsProps = {
  quote: Quote
}

export function QuoteDetails({ quote }: QuoteDetailsProps) {
  return (
    <Layout.Grid>
      <Layout.Stack gap="spacing-4" align="flex-start" paddingB="spacing-4">
        {showAccessorials(quote) && (
          <QuoteAccessorials
            accessorials={quote.accessorials}
            requestedAccessorials={quote.requestedAccessorials}
          />
        )}
        {quote.shipperNotes && <Item label="Shipper Notes" value={quote.shipperNotes} />}
      </Layout.Stack>
    </Layout.Grid>
  )
}
